<template>
    <div class="property-saved-searches-card-actions mr-n2">
        <b-button
                class="action-button edit-button"
                variant="link"
                @click.stop="openPropertySavedSearchesEditModal"
        >
            Edit
        </b-button>
    </div>
</template>

<script>
    import './PropertySavedSearchesCardActions.scss';
    import {PROPERTY_SAVED_SEARCHES_EDIT_MODAL_DISPLAY} from "../PropertySavedSearchesEditModal/PropertySavedSearchesEditModal";
    import PropertySearchFilterAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/PropertySearchFilterAppResource";

    export default {
        name: "PropertySavedSearchesCardActions",

        props: {
            propertySearchFilterAppResource: {
                type: PropertySearchFilterAppResource,
                required: true,
            }
        },

        methods: {
            openPropertySavedSearchesEditModal() {
                this.$bus.$emit(PROPERTY_SAVED_SEARCHES_EDIT_MODAL_DISPLAY, {
                    entity: this.propertySearchFilterAppResource
                });
            },
        },
    };
</script>
